import { ICellRendererParams } from "ag-grid-community";
import { X } from "lucide-react";
import React from "react";

import { IgTooltip } from "@intelligems/ig-theme";
import {
  FullAgencyDto,
  OrganizationAgencyLinkDto,
} from "@intelligems/ig-types";
import { Grid, IconButton, useTheme } from "@mui/material";
import { useDeleteOrganizationAgencyLink } from "@src/api/organization-agency-links/delete-organization-agency-link";
import { AreYouSure } from "@src/components/Popover/AreYouSure";

export const DeleteColumn = (
  params: ICellRendererParams<OrganizationAgencyLinkDto>
) => {
  const deleteOrganizationAgencyLink = useDeleteOrganizationAgencyLink();
  const context = params.context as { agency: FullAgencyDto };
  const theme = useTheme();
  const handleYesClick = () => {
    if (params.data) {
      deleteOrganizationAgencyLink.mutate({
        body: {
          agencyId: params.data.agencyId,
          orgId: params.data.orgId,
          stripeSubscriptionIds: context.agency.subscriptions.map(
            (sub) => sub.stripeSubscriptionId
          ),
        },
        pathParams: undefined,
        queryParams: undefined,
      });
    }
  };

  const hoverText = "Are you sure?";
  const yesMessage = "Yes, delete";

  if (!params.data?.id) {
    return null;
  }

  const isOrgInUse = context.agency.subscriptions.some((s) =>
    s.items.some((i) =>
      i.stripeProductLinks.some(
        (pl) => pl.organization.id === params.data?.orgId
      )
    )
  );

  if (isOrgInUse) {
    return (
      <Grid container item>
        <Grid item>
          <IgTooltip
            title={isOrgInUse ? "This org is assigned to a subscription" : ""}
          >
            <span>
              <IconButton disabled={true}>
                <X size={16} />
              </IconButton>
            </span>
          </IgTooltip>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container item>
      <Grid item>
        <AreYouSure
          enabled={true}
          keyId={"delete-customer-group"}
          buttonText={"Cancel"}
          isLoading={deleteOrganizationAgencyLink.isPending}
          onYesClick={handleYesClick}
          message={hoverText}
          yesMessage={yesMessage}
        >
          <IconButton disabled={deleteOrganizationAgencyLink.isPending}>
            <X size={16} color={theme.igIconColors.error} />
          </IconButton>
        </AreYouSure>
      </Grid>
    </Grid>
  );
};
